/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as DevRouteImport } from './routes/dev'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as R403RouteImport } from './routes/403'
import { Route as AuthedIndexRouteImport } from './routes/_authed/index'
import { Route as DevComponentsRouteImport } from './routes/dev/components'
import { Route as AuthedUsersRouteImport } from './routes/_authed/users'
import { Route as AuthedStatisticsRouteImport } from './routes/_authed/statistics'
import { Route as AuthedPresenceRouteImport } from './routes/_authed/presence'
import { Route as AuthedPipelinesRouteImport } from './routes/_authed/pipelines'
import { Route as AuthedMonitoringRouteImport } from './routes/_authed/monitoring'
import { Route as AuthedLogsRouteImport } from './routes/_authed/logs'
import { Route as AuthedLinksRouteImport } from './routes/_authed/links'
import { Route as AuthedEntitiesRouteImport } from './routes/_authed/entities'
import { Route as AuthedDataRouteImport } from './routes/_authed/data'
import { Route as AuthedConfigRouteImport } from './routes/_authed/config'
import { Route as AuthedAnalyticsRouteImport } from './routes/_authed/analytics'
import { Route as AuthedAlertsRouteImport } from './routes/_authed/alerts'
import { Route as AuthedGroupDashboardGroupIdRouteImport } from './routes/_authed/group-dashboard.$groupId'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const DevRoute = DevRouteImport.update({
  id: '/dev',
  path: '/dev',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const R403Route = R403RouteImport.update({
  id: '/403',
  path: '/403',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedRoute,
} as any)
const DevComponentsRoute = DevComponentsRouteImport.update({
  id: '/components',
  path: '/components',
  getParentRoute: () => DevRoute,
} as any)
const AuthedUsersRoute = AuthedUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedStatisticsRoute = AuthedStatisticsRouteImport.update({
  id: '/statistics',
  path: '/statistics',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPresenceRoute = AuthedPresenceRouteImport.update({
  id: '/presence',
  path: '/presence',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPipelinesRoute = AuthedPipelinesRouteImport.update({
  id: '/pipelines',
  path: '/pipelines',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedMonitoringRoute = AuthedMonitoringRouteImport.update({
  id: '/monitoring',
  path: '/monitoring',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedLogsRoute = AuthedLogsRouteImport.update({
  id: '/logs',
  path: '/logs',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedLinksRoute = AuthedLinksRouteImport.update({
  id: '/links',
  path: '/links',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedEntitiesRoute = AuthedEntitiesRouteImport.update({
  id: '/entities',
  path: '/entities',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDataRoute = AuthedDataRouteImport.update({
  id: '/data',
  path: '/data',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedConfigRoute = AuthedConfigRouteImport.update({
  id: '/config',
  path: '/config',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAnalyticsRoute = AuthedAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAlertsRoute = AuthedAlertsRouteImport.update({
  id: '/alerts',
  path: '/alerts',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedGroupDashboardGroupIdRoute =
  AuthedGroupDashboardGroupIdRouteImport.update({
    id: '/group-dashboard/$groupId',
    path: '/group-dashboard/$groupId',
    getParentRoute: () => AuthedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/403': typeof R403Route
  '/': typeof AuthedIndexRoute
  '/dev': typeof DevRouteWithChildren
  '/login': typeof LoginRoute
  '/alerts': typeof AuthedAlertsRoute
  '/analytics': typeof AuthedAnalyticsRoute
  '/config': typeof AuthedConfigRoute
  '/data': typeof AuthedDataRoute
  '/entities': typeof AuthedEntitiesRoute
  '/links': typeof AuthedLinksRoute
  '/logs': typeof AuthedLogsRoute
  '/monitoring': typeof AuthedMonitoringRoute
  '/pipelines': typeof AuthedPipelinesRoute
  '/presence': typeof AuthedPresenceRoute
  '/statistics': typeof AuthedStatisticsRoute
  '/users': typeof AuthedUsersRoute
  '/dev/components': typeof DevComponentsRoute
  '/group-dashboard/$groupId': typeof AuthedGroupDashboardGroupIdRoute
}
export interface FileRoutesByTo {
  '/403': typeof R403Route
  '/dev': typeof DevRouteWithChildren
  '/login': typeof LoginRoute
  '/alerts': typeof AuthedAlertsRoute
  '/analytics': typeof AuthedAnalyticsRoute
  '/config': typeof AuthedConfigRoute
  '/data': typeof AuthedDataRoute
  '/entities': typeof AuthedEntitiesRoute
  '/links': typeof AuthedLinksRoute
  '/logs': typeof AuthedLogsRoute
  '/monitoring': typeof AuthedMonitoringRoute
  '/pipelines': typeof AuthedPipelinesRoute
  '/presence': typeof AuthedPresenceRoute
  '/statistics': typeof AuthedStatisticsRoute
  '/users': typeof AuthedUsersRoute
  '/dev/components': typeof DevComponentsRoute
  '/': typeof AuthedIndexRoute
  '/group-dashboard/$groupId': typeof AuthedGroupDashboardGroupIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/403': typeof R403Route
  '/_authed': typeof AuthedRouteWithChildren
  '/dev': typeof DevRouteWithChildren
  '/login': typeof LoginRoute
  '/_authed/alerts': typeof AuthedAlertsRoute
  '/_authed/analytics': typeof AuthedAnalyticsRoute
  '/_authed/config': typeof AuthedConfigRoute
  '/_authed/data': typeof AuthedDataRoute
  '/_authed/entities': typeof AuthedEntitiesRoute
  '/_authed/links': typeof AuthedLinksRoute
  '/_authed/logs': typeof AuthedLogsRoute
  '/_authed/monitoring': typeof AuthedMonitoringRoute
  '/_authed/pipelines': typeof AuthedPipelinesRoute
  '/_authed/presence': typeof AuthedPresenceRoute
  '/_authed/statistics': typeof AuthedStatisticsRoute
  '/_authed/users': typeof AuthedUsersRoute
  '/dev/components': typeof DevComponentsRoute
  '/_authed/': typeof AuthedIndexRoute
  '/_authed/group-dashboard/$groupId': typeof AuthedGroupDashboardGroupIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/403'
    | '/'
    | '/dev'
    | '/login'
    | '/alerts'
    | '/analytics'
    | '/config'
    | '/data'
    | '/entities'
    | '/links'
    | '/logs'
    | '/monitoring'
    | '/pipelines'
    | '/presence'
    | '/statistics'
    | '/users'
    | '/dev/components'
    | '/group-dashboard/$groupId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/403'
    | '/dev'
    | '/login'
    | '/alerts'
    | '/analytics'
    | '/config'
    | '/data'
    | '/entities'
    | '/links'
    | '/logs'
    | '/monitoring'
    | '/pipelines'
    | '/presence'
    | '/statistics'
    | '/users'
    | '/dev/components'
    | '/'
    | '/group-dashboard/$groupId'
  id:
    | '__root__'
    | '/403'
    | '/_authed'
    | '/dev'
    | '/login'
    | '/_authed/alerts'
    | '/_authed/analytics'
    | '/_authed/config'
    | '/_authed/data'
    | '/_authed/entities'
    | '/_authed/links'
    | '/_authed/logs'
    | '/_authed/monitoring'
    | '/_authed/pipelines'
    | '/_authed/presence'
    | '/_authed/statistics'
    | '/_authed/users'
    | '/dev/components'
    | '/_authed/'
    | '/_authed/group-dashboard/$groupId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  R403Route: typeof R403Route
  AuthedRoute: typeof AuthedRouteWithChildren
  DevRoute: typeof DevRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev': {
      id: '/dev'
      path: '/dev'
      fullPath: '/dev'
      preLoaderRoute: typeof DevRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/403': {
      id: '/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof R403RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/': {
      id: '/_authed/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/dev/components': {
      id: '/dev/components'
      path: '/components'
      fullPath: '/dev/components'
      preLoaderRoute: typeof DevComponentsRouteImport
      parentRoute: typeof DevRoute
    }
    '/_authed/users': {
      id: '/_authed/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AuthedUsersRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/statistics': {
      id: '/_authed/statistics'
      path: '/statistics'
      fullPath: '/statistics'
      preLoaderRoute: typeof AuthedStatisticsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/presence': {
      id: '/_authed/presence'
      path: '/presence'
      fullPath: '/presence'
      preLoaderRoute: typeof AuthedPresenceRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/pipelines': {
      id: '/_authed/pipelines'
      path: '/pipelines'
      fullPath: '/pipelines'
      preLoaderRoute: typeof AuthedPipelinesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/monitoring': {
      id: '/_authed/monitoring'
      path: '/monitoring'
      fullPath: '/monitoring'
      preLoaderRoute: typeof AuthedMonitoringRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/logs': {
      id: '/_authed/logs'
      path: '/logs'
      fullPath: '/logs'
      preLoaderRoute: typeof AuthedLogsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/links': {
      id: '/_authed/links'
      path: '/links'
      fullPath: '/links'
      preLoaderRoute: typeof AuthedLinksRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/entities': {
      id: '/_authed/entities'
      path: '/entities'
      fullPath: '/entities'
      preLoaderRoute: typeof AuthedEntitiesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/data': {
      id: '/_authed/data'
      path: '/data'
      fullPath: '/data'
      preLoaderRoute: typeof AuthedDataRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/config': {
      id: '/_authed/config'
      path: '/config'
      fullPath: '/config'
      preLoaderRoute: typeof AuthedConfigRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/analytics': {
      id: '/_authed/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AuthedAnalyticsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/alerts': {
      id: '/_authed/alerts'
      path: '/alerts'
      fullPath: '/alerts'
      preLoaderRoute: typeof AuthedAlertsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/group-dashboard/$groupId': {
      id: '/_authed/group-dashboard/$groupId'
      path: '/group-dashboard/$groupId'
      fullPath: '/group-dashboard/$groupId'
      preLoaderRoute: typeof AuthedGroupDashboardGroupIdRouteImport
      parentRoute: typeof AuthedRoute
    }
  }
}

interface AuthedRouteChildren {
  AuthedAlertsRoute: typeof AuthedAlertsRoute
  AuthedAnalyticsRoute: typeof AuthedAnalyticsRoute
  AuthedConfigRoute: typeof AuthedConfigRoute
  AuthedDataRoute: typeof AuthedDataRoute
  AuthedEntitiesRoute: typeof AuthedEntitiesRoute
  AuthedLinksRoute: typeof AuthedLinksRoute
  AuthedLogsRoute: typeof AuthedLogsRoute
  AuthedMonitoringRoute: typeof AuthedMonitoringRoute
  AuthedPipelinesRoute: typeof AuthedPipelinesRoute
  AuthedPresenceRoute: typeof AuthedPresenceRoute
  AuthedStatisticsRoute: typeof AuthedStatisticsRoute
  AuthedUsersRoute: typeof AuthedUsersRoute
  AuthedIndexRoute: typeof AuthedIndexRoute
  AuthedGroupDashboardGroupIdRoute: typeof AuthedGroupDashboardGroupIdRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedAlertsRoute: AuthedAlertsRoute,
  AuthedAnalyticsRoute: AuthedAnalyticsRoute,
  AuthedConfigRoute: AuthedConfigRoute,
  AuthedDataRoute: AuthedDataRoute,
  AuthedEntitiesRoute: AuthedEntitiesRoute,
  AuthedLinksRoute: AuthedLinksRoute,
  AuthedLogsRoute: AuthedLogsRoute,
  AuthedMonitoringRoute: AuthedMonitoringRoute,
  AuthedPipelinesRoute: AuthedPipelinesRoute,
  AuthedPresenceRoute: AuthedPresenceRoute,
  AuthedStatisticsRoute: AuthedStatisticsRoute,
  AuthedUsersRoute: AuthedUsersRoute,
  AuthedIndexRoute: AuthedIndexRoute,
  AuthedGroupDashboardGroupIdRoute: AuthedGroupDashboardGroupIdRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

interface DevRouteChildren {
  DevComponentsRoute: typeof DevComponentsRoute
}

const DevRouteChildren: DevRouteChildren = {
  DevComponentsRoute: DevComponentsRoute,
}

const DevRouteWithChildren = DevRoute._addFileChildren(DevRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  R403Route: R403Route,
  AuthedRoute: AuthedRouteWithChildren,
  DevRoute: DevRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
